import { USER_REQUEST, USER_ERROR, USER_SUCCESS } from '../actions/user'
import Vue from 'vue'
import '../../plugins/axios'
import { AUTH_LOGOUT } from '../actions/auth'
import store from '../../store'
import axios from 'axios'

Vue.use(axios)

const state = { status: '', profile: {} }

const getters = {
  getProfile: state => state.profile,
  isProfileLoaded: state => !!state.profile.username
}

const actions = {
  [USER_REQUEST]: ({ commit, dispatch }) => {
    commit(USER_REQUEST)
    const config = {
      method: 'get',
      url: 'https://clubtest.intrare.app/users/me/',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Token ' + store.getters.getToken
      }
    }
    axios(config).then(resp => {
      commit(USER_SUCCESS, resp.data)
    }).catch(resp => {
      commit(USER_ERROR)
      dispatch(AUTH_LOGOUT)
    })
  }
}

const mutations = {
  [USER_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [USER_SUCCESS]: (state, resp) => {
    state.status = 'success'
    Vue.set(state, 'profile', resp)
    localStorage.setItem('user_role', resp.role)
    if (resp.permissions) {
      localStorage.setItem('user_permissions', JSON.stringify(resp.permissions))
    }
  },
  [USER_ERROR]: (state) => {
    state.status = 'error'
  },
  [AUTH_LOGOUT]: (state) => {
    state.profile = {}
    localStorage.removeItem('user_role')
    localStorage.removeItem('user_permissions')
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
